import { formatProposalForCheckout } from '@/domain/proposal/mapper/proposal-mapper';
import { prepareCheckoutData } from '@/domain/proposal/proposal-checkout.domain';
import { getUserData } from '@/libs/utils/user';
const user_data = getUserData();

export function makeLoadProposalsDealsUseCase(
  { proposalsDealsRepository }, 
  vanity_name, 
  current_page = 1, 
  per_page = 5, 
  chat_uuid = null,
  current_page_private_deals = 1,
  per_page_private_deals = 5
) {
  return async function loadHomeData() {

    const [proposals, details] = await Promise.all(
      !vanity_name ? [proposalsDealsRepository.myDeals({}, current_page, per_page), proposalsDealsRepository.getDetailsProposals(user_data?.meta_info?.vanity_name)] : [
        proposalsDealsRepository.getProposalsUser({}, vanity_name, current_page, per_page),
        proposalsDealsRepository.getDetailsProposals(vanity_name),
      ]);
    const proposal_for_checkout = formatProposalForCheckout(details);
    const string_key = proposals?.results?.[0]?.user_network?.current_plan?.string_key ?? null;
    let private_deals = null;
    if (chat_uuid) private_deals = await proposalsDealsRepository.dealsPrivate({}, chat_uuid, current_page_private_deals, per_page_private_deals);

    return { proposals, details, proposal_for_checkout, string_key, private_deals };
  };
}

export function makeLoadProposalsPageUseCase({ proposalsDealsRepository }, vanity_name, current_page = 1, per_page = 5, filters_deals = {}) {
  return async function loadProposalsPage() {
    const proposals = !vanity_name ? await proposalsDealsRepository.myDeals(filters_deals, current_page, per_page) : await proposalsDealsRepository.getProposalsUser(filters_deals, vanity_name, current_page, per_page);

    const string_key = proposals?.results?.[0]?.user_network?.current_plan?.string_key ?? null;
    return { proposals, string_key };
  };
}

export function makeLoadPrivateDeals({ proposalsDealsRepository }, chat_uuid, current_page = 1, per_page = 5, filters_deals = {}) {
  return async function loadProposalsPage() {
    const proposals = await proposalsDealsRepository.dealsPrivate(filters_deals, chat_uuid, current_page, per_page);
    return { proposals };
  };
}

export function makeLoadMyDealsUseCase({ myDealsRepository }) {
  return async function loadMyDeals() {
    const [deals, work_summary] = await Promise.all([
      myDealsRepository.getDealsBySession({}),
      myDealsRepository.getWorkSummary(),
    ]);

    return { deals, work_summary };
  };
}

export function makeCreateChatBrandmeTalentUseCase({ proposalsDealsRepository }, user_id) {
  return async function createChatBrandmeTalent() {
    const chat = await proposalsDealsRepository.createChatBrandmeTalent({ user_id });
    return chat;
  };
}

export function makeCreateCheckoutUseCase({ proposalsDealsRepository }, proposal_uuid, deal_uuid, apply_balance = false, balance_discount = 0) {
  return async function createCheckout() {
    const data = prepareCheckoutData(apply_balance, balance_discount);
    const checkout = await proposalsDealsRepository.createCheckout(data, proposal_uuid, deal_uuid);
    return checkout;
  };
}

export function makeCreateUpdateDetailDeailsUseCase({ proposalsDealsRepository }, data) {
  return async function createUpdateDetailDeals() {
    const detailDeals = await proposalsDealsRepository.createUpdateDetailDeals(data);
    return detailDeals;
  };
}

export function makeExecuteProposalBuyFlowUseCase(
  { proposalsDealsRepository },
  {
    deal_selected,
    is_brandme_talent,
    apply_balance = false,
    balance_discount = 0,
    user_id,
  }
) {
  return async function executeProposalBuyFlow() {
    if (is_brandme_talent) {
      const chat = await proposalsDealsRepository.createChatBrandmeTalent({ user_id });
      return {
        type: 'chat',
        chat_uuid: chat.uuid,
      };
    }

    const checkout_data = prepareCheckoutData(apply_balance, balance_discount);
    const checkout = await proposalsDealsRepository.createCheckout(checkout_data, deal_selected.uuid);
    return {
      type: 'checkout',
      url: checkout.url,
    };
  };
}

export function makeExecutionCreateUpdateDealUseCase({ crudDealsRepository }, deal_uuid, data) {
  return async function executeCreateUpdateDeal() {
    if (deal_uuid) {
      return await crudDealsRepository.updateDeal(deal_uuid, data);
    }
    return await crudDealsRepository.createDeal(data);
  };
}

export function makeDeleteDealUseCase({ crudDealsRepository }, deal_uuid) {
  return async function deleteDeal() {
    return await crudDealsRepository.deleteDeal(deal_uuid);
  };
}